// @ts-nocheck
import { useTranslation } from 'react-i18next'
import { useQuery } from '@apollo/client/react'
import useWindowScrollPosition from 'helpers/useWindowScrollPosition'

import { Container } from 'js/components/Grid'
import PageHeader from 'js/components/PageHeader/PageHeader'
import Section from 'js/components/Section/Section'
import FeedView from 'js/page/Widget/components/Feed/FeedView'

import { DISCUSSIONS_LIST_WRAPPER } from './List.queries'

// First load data, otherwise useWindowScrollPosition and FeedView won't work properly
const ListWrapper = () => {
    const { data, loading } = useQuery<any>(DISCUSSIONS_LIST_WRAPPER)

    if (loading) {
        return null
    }
    return <List data={data} />
}

const List = ({ data }) => {
    const { viewer, site } = data

    const { t } = useTranslation()

    const settings = {
        showTagFilter: site?.pageTagFilters.showAllTagCategories,
        showTagCategories: site?.pageTagFilters.showTagCategories,
        sortingOptions: ['timePublished', 'lastAction', 'timeUpdated'],
        typeFilter: ['discussion'],
        sortBy: 'lastAction',
        sortDirection: 'desc',
        itemView: 'list',
        itemCount: 10,
    }

    useWindowScrollPosition('discussions')

    return (
        <>
            <PageHeader
                title={t('entity-discussion.name', { count: 2 })}
                canCreate={viewer && viewer.canWriteToContainer}
                createLink="/discussion/add"
                createLabel={t('entity-discussion.create')}
            />
            <Section>
                <Container size="tiny">
                    <FeedView guid="discussions" settings={settings} />
                </Container>
            </Section>
        </>
    )
}

export default ListWrapper
